"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSelect = void 0;
const react_1 = __importStar(require("react"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const material_1 = require("@mui/material");
const arrow_svg_1 = __importDefault(require("@components/icons/arrow.svg"));
const common_1 = require("@components/common");
const StyledSelect = (0, material_1.styled)(Select_1.default)(() => ({
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none'
    },
    '& .MuiSelect-outlined': {
        padding: '0',
        paddingRight: '0!important',
        fontFamily: 'Inter',
        color: '#7B4EF8',
        textAlign: 'end',
        fontSize: '11px'
    },
    '& img': {
        width: '16px'
    },
    'ul li.MuiButtonBase-root': {
        fontSize: '11px!important'
    }
}));
const ChartSelect = ({ onChange, options, value, style }) => {
    const arrowRef = (0, react_1.useRef)();
    return (react_1.default.createElement(StyledSelect, { value: value, onChange: onChange, className: "chart-select", style: style, IconComponent: () => react_1.default.createElement(common_1.Box, { className: "mui-select-arrow" },
            react_1.default.createElement(arrow_svg_1.default, null)), onOpen: (ev) => {
            // @ts-ignore
            arrowRef.current = ev.target.parentElement.querySelector('.mui-select-arrow');
            // @ts-ignore
            arrowRef.current.classList.add('open');
        }, 
        // @ts-ignore
        onClose: () => arrowRef.current.classList.remove('open') }, options === null || options === void 0 ? void 0 : options.map(e => react_1.default.createElement(MenuItem_1.default, { key: e.value, value: e.value }, e.name))));
};
exports.ChartSelect = ChartSelect;
